import { Card } from "common/Card";
import { formatDate } from "date-fns";
import { ChevronRight } from "lucide-react";
import { IconButton, IconButtonSize } from "shared/components";
import { Loader } from "shared/components/Loader";
import { CreditScore } from "types/credit-score";
import { CreditScoreGauge } from "views/credit-monitoring/CreditScoreGauge";

export const CreditMonitoringCard = ({
  creditScore,
  isPending
}: {
  creditScore?: CreditScore | null;
  isPending?: boolean;
}) => {
  if (isPending)
    return (
      <div className="flex items-center justify-center h-[316px]">
        <Loader />
      </div>
    );
  return (
    <Card
      className="max-w-[342px] w-full h-[316px] shrink-0"
      linkTo={"/credit-monitoring"}
    >
      <div className="pb-0 flex flex-col">
        <div className="px-4 h-[52px] flex items-center justify-between gap-2 border-b border-alpha-40">
          <h2 className="text-sm font-medium text-content-1000">
            Credit monitoring
          </h2>
          <IconButton
            Icon={ChevronRight}
            size={IconButtonSize.SM}
            borderLess
            className="translate-x-2"
          />
        </div>
        <div className="py-6">
          <CreditScoreGauge score={creditScore?.score} />
        </div>

        {creditScore && creditScore.reported_at ? (
          <span className="px-4 text-xs text-content-600">
            Last updated:{" "}
            {formatDate(creditScore.reported_at || "", "MMM d, yyyy")}
          </span>
        ) : (
          <span className="px-4 text-xs text-content-600 text-center">
            Credit score is not available at this time
          </span>
        )}
      </div>
    </Card>
  );
};
